// Recalculate heights for open FAQ items after DOM update (e.g. variant change).
document.addEventListener('variant-picker:updated', function () {
  document.querySelectorAll('.product-faq__item--open').forEach(function (item) {
    var answer = /** @type {HTMLElement} */ (item.querySelector('.product-faq__answer'));
    if (!answer) return;
    answer.style.height = answer.scrollHeight + 'px';
  });
});

document.addEventListener('click', function (e) {
  var trigger = /** @type {Element} */ (e.target)?.closest('.product-faq__trigger');
  if (!trigger) return;

  var item = trigger.closest('.product-faq__item');
  if (!item) return;

  var faq = item.closest('.product-faq');
  if (!faq) return;

  var isOpen = item.classList.contains('product-faq__item--open');

  faq.querySelectorAll('.product-faq__item--open').forEach(function (openItem) {
    closeItem(openItem);
  });

  if (!isOpen) openItem(item);
});

/**
 * Attach a single transitionend listener to an answer element,
 * cancelling any previously registered one to prevent handler stacking
 * on rapid clicks.
 * @param {HTMLElement} answer
 * @param {() => void} callback
 */
function onTransitionEnd(answer, callback) {
  if (answer._faqEnd) {
    answer.removeEventListener('transitionend', answer._faqEnd);
  }
  answer._faqEnd = function () {
    answer.removeEventListener('transitionend', answer._faqEnd);
    answer._faqEnd = null;
    callback();
  };
  answer.addEventListener('transitionend', answer._faqEnd);
}

function closeItem(item) {
  var trigger = item.querySelector('.product-faq__trigger');
  var answer = /** @type {HTMLElement} */ (item.querySelector('.product-faq__answer'));
  if (!answer || !trigger) return;

  // Cancel in-flight transition and snap to current height before animating to 0.
  answer.style.transition = 'none';
  answer.style.height = answer.scrollHeight + 'px';
  answer.offsetHeight; // force reflow
  answer.style.transition = 'height 0.3s ease';
  answer.style.height = '0';

  item.classList.remove('product-faq__item--open');
  trigger.setAttribute('aria-expanded', 'false');

  onTransitionEnd(answer, function () {
    answer.hidden = true;
    answer.style.cssText = '';
  });
}

function openItem(item) {
  var trigger = item.querySelector('.product-faq__trigger');
  var answer = /** @type {HTMLElement} */ (item.querySelector('.product-faq__answer'));
  if (!answer || !trigger) return;

  answer.hidden = false;
  // Cancel in-flight transition before starting open animation.
  answer.style.transition = 'none';
  answer.style.height = '0';
  answer.style.overflow = 'hidden';
  answer.style.visibility = 'visible';
  answer.offsetHeight; // force reflow
  answer.style.transition = 'height 0.3s ease';
  answer.style.height = answer.scrollHeight + 'px';

  item.classList.add('product-faq__item--open');
  trigger.setAttribute('aria-expanded', 'true');

  onTransitionEnd(answer, function () {
    answer.style.cssText = '';
  });
}
